import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import TextInputField from "../Form/TextInputField";
import { RenderLoading } from "../RTRegistration/AddPartyPopup";
import { StringUtil } from "@eres/core";
import { OwnerVIPDocument, OwnerVIPRequest } from "@eres/vipownerapi/entities";
import { getParticipantID } from "@10x/sso";
import { REQ_SOURCE_DLD_WEB } from "@eres/rtregistrationapi/entities";
import { VIPOwnerAPI } from "@eres/vipownerapi";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import Dropzone from "react-dropzone";
import DocumentInputField from "../Form/DocumentInputField";
import { getTabuDocDate, getTabuDocName, getTabuDocSize, getTabuDocType, TabuDocTypes } from "@my-dld/utils/TabuUtils";
import { getImagePreview, TabuDoc } from "@my-dld/screens/TabuRequest/BaseTabuRequestForm";
import { showErrorMessage } from "@my-dld/utils/UIUtils";

interface Props {
	onDismiss: ( requestNo?: number ) => void;
}

interface State {
	isLoading?: boolean;
	message?: string;
	docs: TabuDoc[];
	requestNo?: number;
	error: { [ k: string ]: string };
	errorMessage?: string;
	docsErrorMessage?: string;
}

const MAX_UPLOAD_FILES = 4;

class SendMessagePopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			docs: [],
			error: {},
		};
	}

	render() {
		const { isLoading, docs, requestNo, error, errorMessage, docsErrorMessage } = this.state;
		const holder1 = Strings.enter_your_message;
		const holder2 = Strings.max_characters.replace( "~", "1000" );
		const label = holder1 + ` (${ holder2 })`;
		return <React.Fragment>
			<Popup
				id={ "SendMessage" } modalSubContainer="modal-dialog modal-dialog-centered"
				title={ Strings.send_message }
				showIcon={ false } modalBodyContainer={ "modal-body" }
				onDismiss={ () => this.props.onDismiss( requestNo ) }>
				{ errorMessage && <div>
					<div className="alert alert-danger">{ errorMessage }</div>
				</div> }
				{ requestNo == undefined && <>
					<TextInputField
						id={ "message" }
						holder={ this }
						required={ true }
						label={ label }
						customInput={ <textarea rows={ 4 } maxLength={ 1000 }/> }
						error={ error.message }/>
					<RenderUploadDocs
						docs={ docs }
						onDropRejected={ this.onDropRejected }
						onDrop={ this.onDrop }
						onDelete={ this.onDelete }
						errorMsg={ docsErrorMessage }/>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn_1" onClick={ this.onSend }>{ Strings.send }</button>
						<button type="button" className="btn btn-link" data-bs-dismiss="modal">{ Strings.cancel }</button>
					</div>
				</> }
				{ requestNo !== undefined && <div className="send-message-success">
					<div className="check-icon">
						<i className="fa fa-check"/>
					</div>
					<p className="text-center">{ Strings.request_submitted_successfully }</p>
					<div className="refn-box">
						{ Strings.request_number }: <span>{ requestNo }</span>
					</div>
				</div> }
			</Popup>
			{ isLoading && <RenderLoading/> }
		</React.Fragment>;
	}

	private onDropRejected = () => {
		this.setState( {
			docsErrorMessage: Strings.tabu_file_exceed_size,
		} );
	};

	private onDrop = ( files: File[] ) => {
		const { docs } = this.state;
		if ( docs && docs.length > 0 ) {
			let maxAllowed = ( MAX_UPLOAD_FILES - docs.length );
			if ( files.length > maxAllowed )
				files = files.splice( 0, maxAllowed );
		} else if ( files.length > MAX_UPLOAD_FILES ) {
			files = files.splice( 0, MAX_UPLOAD_FILES );
		}
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( file ) );
	};

	private addFile( file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			const attachedDoc: TabuDoc = {
				identity: -1,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
			};
			this.setState( {
				docsErrorMessage: undefined,
				docs: this.state.docs.concat( attachedDoc ),
			} );
		};
		reader.readAsDataURL( file );
	}

	private onDelete = ( index: any ) => {
		const { docs } = this.state;
		docs.splice( index, 1 );
		this.setState( {
			docs: docs,
		} );
	};

	private onSend = () => {
		const { docs } = this.state;
		if ( this.isValid() ) {
			this.setState( { isLoading: true } );
			if ( docs && docs.length > 0 ) {
				VIPOwnerAPI.uploadDocuments( docs ).then( ( uDocs ) => {
					this.setState( { docs: uDocs }, () => {
						this.sendOwnerVIPRequest();
					} );
				} ).catch( ( reason ) => {
					this.setState( { isLoading: false } );
					showErrorMessage( reason );
				} );
			} else {
				this.sendOwnerVIPRequest();
			}
		}
	};

	private isValid() {
		const { message } = this.state;
		const error: { [ k: string ]: string } = {};
		let isValid = true;
		if ( StringUtil.isEmptyStringOrNull( message ) ) {
			error.message = Strings.required;
			isValid = false;
		}
		this.setState( {
			error: error,
		} );
		return isValid;
	}

	private sendOwnerVIPRequest() {
		const participantId = getParticipantID()!;
		const request = this.getRequest();
		VIPOwnerAPI.saveVIPOwnerRequest( request, participantId ).then( ( response: any ) => {
			const reqNumber = response.RequestNumber;
			trackEventWithData( "VIPRequest", "SubmitSuccess", { requestNumber: "" + reqNumber } );
			this.setState( {
				isLoading: false,
				requestNo: reqNumber,
			} );
		} ).catch( ( reason ) => {
			trackEventWithData( "VIPRequest", "SubmitFailed", { message: reason } );
			this.setState( { isLoading: false, errorMessage: reason } );
		} );
	}

	private getRequest(): OwnerVIPRequest {
		const { message, docs } = this.state;
		const participantId = getParticipantID()!;
		let uploadDocs: OwnerVIPDocument[] | undefined = undefined;
		if ( docs && docs.length > 0 ) {
			uploadDocs = [];
			docs.map( ( doc: TabuDoc ) => {
				const uploadDoc: OwnerVIPDocument = {
					DocumentName: doc.fileName!,
					DocumentPath: doc.fileUrl!,
				};
				uploadDocs!.push( uploadDoc );
			} );
		}
		return {
			OwnerParticipantId: participantId,
			RequestDescriptionEn: message!,
			RequestDescriptionAR: message!,
			RequestSource: REQ_SOURCE_DLD_WEB,
			Documents: uploadDocs,
		};
	}
}

function RenderUploadDocs( props: {
	docs: TabuDoc[], onDropRejected: () => void,
	onDrop: ( files: File[] ) => void, onDelete: ( index: number ) => void,
	errorMsg?: string, docsError?: any,
} ) {
	const { docs, onDropRejected, onDrop, onDelete, errorMsg, docsError } = props;
	return ( <div className="row">
		<div className="col-md-12 font-weight-bold mb-3">{ Strings.upload_documents }
			<span className="d-flex">
                <small>{ Strings.max_num_files + " : " + MAX_UPLOAD_FILES }</small>
            </span>
			<span className="d-flex">
                <small>{ Strings.tabu_upload_documents_note }</small>
            </span>
		</div>
		<div className="col-md-12">
			{ errorMsg && <div className="alert alert-danger">{ errorMsg }</div> }
		</div>
		<div className="col-md-12">
			<Dropzone
				multiple={ true }
				maxSize={ 2 * 1024 * 1000 }
				onDropRejected={ onDropRejected }
				onDrop={ ( files: File[] ) => {
					onDrop( files );
				} }
				accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
				{ ( { getRootProps, getInputProps } ) => (
					<DocumentInputField { ...getRootProps() }
					                    dropZoneInputProps={ getInputProps() }
					                    label={ "" }/>
				) }
			</Dropzone>
			{ docs.map( ( doc: TabuDoc, index: number ) => {
				return <RenderUploadDoc
					doc={ doc } onDelete={ () => {
					onDelete( index );
				} }/>;
			} ) }
		</div>
	</div> );
}

export function RenderUploadDoc( props: { doc: TabuDoc, onDelete: () => void } ) {
	const { doc, onDelete } = props;
	let docType = getTabuDocType( doc );
	let preview = ( docType === TabuDocTypes.PDF ) ? <i className="far fa-file-pdf"/> : getImagePreview( doc );
	return <div className={ "mb-2 table-responsive" }>
		<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
			<thead>
			<tr>
				<th>{ Strings.file }</th>
				<th>{ Strings.name }</th>
				<th>{ Strings.size }</th>
				<th>{ Strings.vid_date }</th>
				<th>{ Strings.action }</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td data-label={ Strings.file }>{ preview }</td>
				<td data-label={ Strings.name }>{ getTabuDocName( doc ) }</td>
				<td data-label={ Strings.size }>{ getTabuDocSize( doc ) + " " + Strings.size_mb }</td>
				<td data-label={ Strings.vid_date }>{ getTabuDocDate( doc ) }</td>
				<td data-label={ Strings.action }>
					<button className="btn btn-grey" onClick={ onDelete }>
						<i className="far fa-trash-alt"/>{ Strings.delete }
					</button>
				</td>
			</tr>
			</tbody>
		</table>
	</div>;
}

export default SendMessagePopup;
